module.exports = "pegasus/assets/hexline-twitter-old.png";